import { useCallback } from 'react';

export const useMatrixEventHandler = (synapseRoomId, showChat, dispatch, loggedInUser) => {
    
    const handleNewMessage = useCallback((event) => {
        console.log('ð Raw Matrix event:', {
            type: event.getType(),
            roomId: event.getRoomId(),
            sender: event.getSender(),
            eventId: event.getId(),
            hasRoomId: !!event.getRoomId(),
            eventObject: event.event,
            rawEvent: event
        });
        
        if (event.getType() === 'm.room.message') {
            const eventRoomId = event.getRoomId();
            const eventSender = event.getSender();
            const currentUser = loggedInUser?.synapse_user_id;
            const isOwnMessage = eventSender === currentUser;
            
            console.log('ð Matrix message:', {
                roomId: eventRoomId,
                sender: eventSender,
                isOwnMessage: isOwnMessage,
                currentRoom: synapseRoomId
            });
            
            // Build proper event structure using Matrix event methods
            const eventData = {
                event_id: event.getId(),
                room_id: eventRoomId,
                sender: eventSender,
                content: event.getContent(),
                origin_server_ts: event.getTs(),
                type: event.getType()
            };
            
            console.log('ð Event data structure:', eventData);
            
            // Always add the message to Redux store regardless of modal state
            dispatch({ type: 'addSynapseEvents', payload: [eventData] });
            
            // Handle notifications for receiver when chat modal is closed
            if (eventRoomId === synapseRoomId && !showChat && !isOwnMessage) {
                console.log('ð New message for receiver - updating notifications');
                
                const currentNotification = {
                    roomKey: synapseRoomId,
                    notificationCount: 1
                };
                dispatch({ type: 'setRoomsNotifications', payload: [currentNotification] });
            }
            
            // Always save to localStorage for persistence
            if (eventRoomId) {
                try {
                    const allChatMessages = JSON.parse(localStorage.getItem('chatMessages') || '{}');
                    if (!allChatMessages[eventRoomId]) {
                        allChatMessages[eventRoomId] = { messages: [], timestamp: Date.now() };
                    }
                    
                    // Check if message already exists to avoid duplicates
                    const messageExists = allChatMessages[eventRoomId].messages.some(msg => msg.event_id === eventData.event_id);
                    if (!messageExists) {
                        allChatMessages[eventRoomId].messages.push(eventData);
                        allChatMessages[eventRoomId].timestamp = Date.now();
                        localStorage.setItem('chatMessages', JSON.stringify(allChatMessages));
                        console.log('ð Saved new message to storage:', eventData.event_id);
                    }
                } catch (error) {
                    console.error('Error saving message to storage:', error);
                }
            }
        }
    }, [synapseRoomId, showChat, dispatch, loggedInUser?.synapse_user_id]);

    return { handleNewMessage };
};
